export { LMSDialogComponent } from './dialogs/lms-dialog/lms-dialog.component';
export { LMSDatePickerModule } from '../core/constants/datepicker-adapter';
export {
  HighlightDirective, LMS_NoPasteDirective, LMS_NoSpecialsDirective, LMSSelectOptionDirective, NumbersOnlyDirective,
  UpperCaseInputDirective,
} from './directives';
export { NoSpecialCharPipe, UpperCaseSearchListPipe, ZAcurrencyPipe, ZARcurrencyPipe } from './pipes';
export * from './ui';
export * from './shared-ui.module';

// export { LMSDialogComponent } from './dialogs/lms-dialog/lms-dialog.component';
// export { LMSDatePickerModule } from '../core/constants/datepicker-adapter';
// export { LmsPaginateComponent } from './ui/lms-paginate/lms-paginate.component';
// export { DocumentViewerComponent } from './ui/document-viewer/document-viewer.component';
// export { LmsGridviewComponent } from './ui/lms-gridview/lms-gridview.component';
// export { LmsClientSearchComponent } from './ui/lmsclient-search/lmsclient-search.component';
// export { PageCardheadComponent } from './ui/pageheader-card/pageheader-card.component';
// export {
//   HighlightDirective,
//   LMS_NoPasteDirective,
//   LMS_NoSpecialsDirective,
//   LMSSelectOptionDirective,
//   NumbersOnlyDirective,
//   UpperCaseInputDirective,
// } from './directives';
// export { NoSpecialCharPipe, UpperCaseSearchListPipe, ZAcurrencyPipe, ZARcurrencyPipe } from './pipes';
// export * from './shared-ui.module';
